// ticketTimerSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchTicketTimer } from "../../utilities/services/ticketTimer";

// Async thunk to fetch ticket timer data
export const getTicketTimerData = createAsyncThunk(
  "ticketTimer/getTicketTimerData",
  async () => {
    const response = await fetchTicketTimer();
    return response.data; 
  }
);

const ticketTimerSlice = createSlice({
  name: "ticketTimer",
  initialState: {
    timerData: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTicketTimerData.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTicketTimerData.fulfilled, (state, action) => {
        state.loading = false;
        state.timerData = action.payload;
      })
      .addCase(getTicketTimerData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default ticketTimerSlice.reducer;
